import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { VendorDto } from '../vendors/models';

@Injectable({
  providedIn: 'root',
})
export class UserVendorService {
  apiName = 'Default';
  

  getCurrentUserAvailableVendors = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, VendorDto[]>({
      method: 'GET',
      url: '/api/app/user-vendor/current-user-available-vendors',
    },
    { apiName: this.apiName,...config });
  

  getCurrentUserVendor = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, VendorDto>({
      method: 'GET',
      url: '/api/app/user-vendor/current-user-vendor',
    },
    { apiName: this.apiName,...config });
  

  updateCurrentUserVendorByVendorId = (vendorId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'PUT',
      url: `/api/app/user-vendor/current-user-vendor/${vendorId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
